export default {
  $nflData: {},
  $profile: {},
  $profiles: {},
  fbTrackModels: {},
  isNFLApp: false
}
